import { useRef } from "react";
import { useNavigate } from "react-router-dom";

export default function SelectPair({ label, value, options, edit, link }) {
  const navigate = useNavigate();
  const clickHandler = () => {
    if (link) navigate(link);
  }
  const classNames = () => {
    if (link) return "cursor-pointer hover:opacity-70"
    else return "";
  }
  
  return (
    <div onClick={clickHandler} className={classNames()}>
      <p className="text-stone-400">{label}:</p>
      {!edit && <p className="text-stone-200">{value || "-"}</p>}
      {edit && (
        <select
          className="w-full form-input"
          defaultValue={value || options[0]}
          name={label}
          id={label}
        >
          {options.map((option, idx) => (
            <option key={idx} value={typeof(option) === "object" ? option.id : option}>
              {typeof(option) === "object" ? option.name : option}
            </option>
          ))}
        </select>
      )}
    </div>
  );
}
